import type React from 'react';
import { cn } from '../../utils/cn';
import {
	RichTextEditor,
	type RichTextEditorTool,
} from '../forms/RichTextEditor';

/**
 * PD-16475 — the formatting an issue message offers. It matches what the
 * issue sanitizer keeps (`sanitizeIssueRichText`): offering a control whose
 * result is stripped on save would be worse than not offering it. Images are
 * attached beside the text (IssueImagePicker), not embedded in it.
 */
export const ISSUE_RICH_TEXT_TOOLS: ReadonlyArray<RichTextEditorTool> = [
	'bold',
	'italic',
	'underline',
	'lists',
	'link',
];

interface IssueRichTextEditorProps {
	value: string;
	onChange: (html: string) => void;
	placeholder?: string;
	minHeight?: string;
	disabled?: boolean;
	/** Border/background of the frame, for apps with their own input look. */
	className?: string;
}

/** The shared rich-text editor, configured for issue messages. */
export function IssueRichTextEditor({
	value,
	onChange,
	placeholder,
	minHeight = '120px',
	disabled = false,
	className,
}: IssueRichTextEditorProps): React.JSX.Element {
	return (
		<div
			className={cn(
				'overflow-hidden rounded-lg border border-default bg-surface',
				className,
			)}
		>
			<RichTextEditor
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				minHeight={minHeight}
				disabled={disabled}
				tools={ISSUE_RICH_TEXT_TOOLS}
			/>
		</div>
	);
}
